import React from "react";
import {
  FaLayerGroup,
  FaShieldAlt,
  FaRocket,
  FaUsersCog,
} from "react-icons/fa";
import "./WhyChoose.css";

const WhyChoose = () => {
  return (
    <section className="uniq-oglitz-why">
      <div className="uniq-oglitz-why__container">
        {/* LEFT CONTENT */}
        <div className="uniq-oglitz-why__content">
          <span className="uniq-oglitz-why__badge">Why Choose Oglitz</span>

          <h2 className="uniq-oglitz-why__title">
            Engineering <span>Premium Digital Products</span>
            <br />
            Built for Growth & Scale
          </h2>

          <p className="uniq-oglitz-why__subtitle">
            Oglitz Software partners with startups, enterprises, and global
            brands to design and build scalable, secure, and high-performance
            digital products — focused on long-term business success.
          </p>
        </div>

        {/* RIGHT FEATURES */}
        <div className="uniq-oglitz-why__grid">
          <div className="uniq-oglitz-why__card">
            <FaLayerGroup />
            <h4>Clean Architecture</h4>
            <p>
              Modular, maintainable, and future-ready systems designed for
              performance and scalability.
            </p>
          </div>

          <div className="uniq-oglitz-why__card">
            <FaShieldAlt />
            <h4>Secure & Reliable</h4>
            <p>
              Enterprise-grade security practices ensuring data protection,
              compliance, and stability.
            </p>
          </div>

          <div className="uniq-oglitz-why__card">
            <FaRocket />
            <h4>Performance Focused</h4>
            <p>
              Optimized applications delivering speed, scalability, and seamless
              user experiences.
            </p>
          </div>

          <div className="uniq-oglitz-why__card">
            <FaUsersCog />
            <h4>Long-Term Partnership</h4>
            <p>
              Beyond delivery — we support, scale, and evolve your product as
              your business grows.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
